import Layout from './layout';
import Sider from './Sider';
Layout.Sider = Sider;
export default Layout;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/layout/index.js
// module id = 644
// module chunks = 0